import React from "react";
import Hero from "../components/Hero";
import AsSeenIn from "../components/AsSeenIn";
import ProductGrid from "../components/ProductGrid";
import Marquee from "../components/Marquee";
import BeforeAfter from "../components/BeforeAfter";
import LovedBy from "../components/LovedBy";
import MoneyBack from "../components/MoneyBack";
import Reviews from "../components/Reviews";
import Newsletter from "../components/Newsletter";

const HomePage = () => {
  return (
    <main>
      <Hero />
      <AsSeenIn />
      <ProductGrid />
      <Marquee />
      <BeforeAfter />
      <LovedBy />
      <MoneyBack />
      <Reviews />
      <Newsletter />
    </main>
  );
};

export default HomePage;
